import mitt from 'mitt';

// Define event types (Replace with actual events used in your project)
type Events = {
  'custom-event': { message: string };
  'loop': { name: string; disable: boolean };
  'loop:overview': void;
};

const eventBus = mitt<Events>();

export default eventBus;